import React, { useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { GuidService } from 'ui-components/services/guid-service';
import { ChildrenPropType } from '../../../../prop-types/children';

const OrderDetailsSessionContext = React.createContext({});
export const useOrderDetailsSessionContext = () => useContext(OrderDetailsSessionContext);

export const ORDER_DETAILS_VERSIONS = {
  VERSION_TWO: 'VERSION_TWO',
};

export const OrderDetailsSessionContextProvider = ({ children, salesOrderId, version }) => {
  const [sessionId, setSessionId] = useState(GuidService.newGuid());
  const [prevSalesOrderId, setPrevSalesOrderId] = useState(salesOrderId);

  if (salesOrderId !== prevSalesOrderId) {
    setPrevSalesOrderId(salesOrderId);
    setSessionId(GuidService.newGuid());
  }

  const value = useMemo(
    () => ({
      version,
      sessionId,
    }),
    [version, sessionId],
  );

  return <OrderDetailsSessionContext.Provider value={value}>{children}</OrderDetailsSessionContext.Provider>;
};

OrderDetailsSessionContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
  version: PropTypes.string.isRequired,
  salesOrderId: PropTypes.string.isRequired,
};
